

class ProductionNoteListViewController extends NoteListViewController
{    
    static newInstance() : ProductionNoteListViewController {
        let vc = new ProductionNoteListViewController('production-note-list-view');
        vc.initWithResource("layout/production_note/ProductionNoteListView.html");
        return vc;
    }

    protected get sectionControllerID():string {
        return SectionViewControllerType.ProductionNote;
    }

    protected noteStatusForSegmentedIndex(index){
        if (index == 1) return StockNoteStatus.Processed;
        return StockNoteStatus.None;
    }

    cellAtIndexPath(tableview, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier('ProductionNoteListCell') as ProductionNoteListCell;    
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ProductionNote;
        
        cell.item = item;
        cell.selected = this.selectedNote == item ? true : false;

        return cell;
    }
        
    protected showSelectedItem(){

        let vc = ProductionNoteDetailViewController.newInstance();
        vc.note = this.selectedNote;
        this.splitViewController.showDetailViewController(vc);
    }

    protected showNoItemSelected(){
        let vc = AppHelper.sharedInstance().emptyViewControllerForIndentifier("ProductionNote", NoItemSelectedViewControllerType.ProductionNote);
        this.splitViewController.showDetailViewController(vc);
    }

    protected showAddNoteViewController(){

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("ADD_PRODUCTION_NOTE", "ADD PRODUCTION NOTE"), MIOLocalizeString("CHOOSE_A_ORIGIN_AND_DESTINATION_WAREHOUSE", "CHOOSE A ORIGIN AND DESTINATION WAREHOUSE"), MUIAlertViewStyle.Default);

        avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){

            DBHelper.sharedInstance().addObserverForEntity(comboBox, 'Warehouse', null, null, null, function (objects) {
                comboBox.removeAllItems();
                for (let i = 0; i < objects.length; i++)
                    comboBox.addItem(objects[i].name, i);
            });
        });

        avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){

            DBHelper.sharedInstance().addObserverForEntity(comboBox, 'Warehouse', null, null, null, function (objects) {
                comboBox.removeAllItems();
                for (let i = 0; i < objects.length; i++)
                    comboBox.addItem(objects[i].name, i);
            });
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("DONE","DONE"), MUIAlertActionStyle.Default, this, function(){
            let originIndex = avc.comboBoxes[0].getSelectedItem();
            let destinationIndex = avc.comboBoxes[1].getSelectedItem();

            DBHelper.sharedInstance().addObserverForEntity(this, 'Warehouse', null, null, null, (objects) => {
                let origin = objects[originIndex] as Warehouse;
                let destination = objects[destinationIndex] as Warehouse;
                DBHelper.createProductionNote(origin, destination, (note:ProductionNote) => {
                    this.selectedNote = note;
                    DBHelper.saveMainContext();
                    this.showSelectedItem();
                });
            });
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL","CANCEL"), MUIAlertActionStyle.Cancel, this, null));

        this.presentViewController(avc, true);
    }

    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("documentID", false)];
        if (this.selectedStatus == StockNoteStatus.Processed) {
            sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("creationDate", false)];
        }   

        let predicateFormat = this.selectedStatus != 0 ? "status == " + this.selectedStatus : "status == 0 OR status == 3";
        predicateFormat += " AND placeID == '" + ad.selectedIdentifier + "'";        
        if(this.searchString != null) {
            predicateFormat += " AND documentID CONTAINS '" + this.searchString + "'";
        }

        if (this.filterPredicateFormat != null) {
            predicateFormat += " AND " + this.filterPredicateFormat;
        }

        let fetchRequest = DBHelper.listFetchRequestWithEntityName("ProductionNote", sortDescriptors, predicateFormat);
        fetchRequest.fetchLimit = 50;
        fetchRequest.relationshipKeyPathsForPrefetching = ["originWarehouse", "destinationWarehouse"];
            
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
    
    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.tableView.reloadData();
	}    
	
	private _filters = null;
    get filters(){
        if (this._filters != null) return this._filters;

        this._filters = [FilterOption.filterWithTitle("FromDate", "From day", "stockDate", FilterFieldType.Date, null, FilterControllerComparatorType.MajorOrEqualComparator, null, "00:00:00"),
                FilterOption.filterWithTitle("ToDate", "To day", "stockDate", FilterFieldType.Date, null, FilterControllerComparatorType.MinorOrEqualComparator, null, "23:59:59"),                
                FilterOption.filterWithFetchRequest("Origin", "From warehouse", "originWarehouse.identifier", FilterFieldType.DropDown, "Warehouse", "name", "identifier", MIOLocalizeString("SELECT_ORIGIN_WAREHOUSE", "Select origin warehouse")),
                FilterOption.filterWithFetchRequest("Destination", "To warehouse", "destinationWarehouse.identifier", FilterFieldType.DropDown, "Warehouse", "name", "identifier", MIOLocalizeString("SELECT_DESTINATION_WAREHOUSE", "Select destination warehouse"))];

        return this._filters;
    }
	
}
